import * as React from 'react';
import { clsx } from 'clsx';
import { UIHeading2, LinkButton, Body1 } from '@cian/ui-kit';
import { IconActionCompareAdd16 } from '@cian/ui-kit-design-tokens/icons';

import emptyIcon from './assets/empty.png';
import * as styles from './EmptyPage.css';
import { NBSP } from '../../constants/text';
import { TComparePageType } from '../../types/comparePageType';

interface IEmptyPageProps {
  isMobile?: boolean;
  notFoundUrl?: string;
  onNotFoundUrlClick?(): void;
  pageType: TComparePageType;
}

export const EmptyPage: React.FC<IEmptyPageProps> = props => {
  const { isMobile, notFoundUrl, onNotFoundUrlClick, pageType } = props;

  const isOffersToCompare = pageType === 'offers';

  const objectType = isOffersToCompare ? 'объявлении' : 'ЖК';
  const buttonText = isOffersToCompare ? 'Выбрать квартиру' : 'Выбрать ЖК';

  return (
    <div className={clsx(styles['container'], isMobile ? styles['container-mobile'] : styles['container-desktop'])}>
      <div>
        <div className={clsx(styles['image-outer'], !isMobile && styles['image-outer-desktop'])}>
          <img src={emptyIcon} alt="" className={styles['image']} />
        </div>
        <div className={styles['title-outer']}>
          <UIHeading2 textAlign="center" as="h1">
            Пока в{NBSP}списке пусто
          </UIHeading2>
        </div>
        <div className={styles['message-outer']}>
          <Body1 textAlign="center">Чтобы сравнить интересные варианты,</Body1>
          <Body1 textAlign="center">
            нажмите
            <span className={styles['icon']}>
              <IconActionCompareAdd16 color="icon-main-default" />
            </span>{' '}
            на{NBSP}
            {objectType}
          </Body1>
        </div>
        <div className={styles['button-outer']}>
          {notFoundUrl && (
            <LinkButton size={isMobile ? 'M' : 'L'} href={notFoundUrl} onClick={onNotFoundUrlClick}>
              {buttonText}
            </LinkButton>
          )}
        </div>
      </div>
    </div>
  );
};
